import { toast } from './components/feedback';

// A send refused by the rules (permission-denied) means a block, since the
// client can't read other people's block lists. Shown as calm info that
// neither reveals the block nor looks like a bug (brief 024).
export const REFUSED = {
  message: "You can't message this person right now.",
  session: "You can't send a session request to this person right now.",
  share: "You can't share with this person right now.",
};

// The wording for a refused send, or null for any other error.
export const refusalText = (action, err) =>
  err?.code === 'permission-denied' ? REFUSED[action] || null : null;

// Toasts the refusal wording as info, or the fallback as an error.
export const sendFailToast = (action, err, fallback) => {
  const refused = refusalText(action, err);
  if (refused) toast(refused);
  else toast(fallback, { type: 'error' });
};
